import React from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/UserPanel';
import './Header.scss';
import { Template } from 'devextreme-react/core/template';
import britamImage from '../../images/logo.png';


export default function Header({ menuToggleEnabled, title, toggleMenu }) {
  const britamImagePath = britamImage;
  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
          <div 
            style={{
              background: `url(${britamImagePath})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
        </Item>
        {/*<Item
          location={'before'}
          cssClass={'header-title'}
          text={title}
          visible={!!title}
        />*/}
        <Item
          location={'before'}
          cssClass={'header-title'}
          style={{
            background: `url(${britamImagePath})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <Item
          location={'after'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <Button
            className={'user-button authorization'}
            width={210}
            height={'100%'}
            stylingMode={'text'}
          >
            <UserPanel menuMode={'context'} />
          </Button>
        </Item>
        <Template name={'userPanelTemplate'}>
          <UserPanel menuMode={'list'} />
        </Template>
      </Toolbar>
    </header>
)}
